import { color } from '../Theme'
import { getSize } from '../theme/iconSizes'
import IconProps from './Icon'

const Error2 = ({ iconSize, fillColor = color('red') }: IconProps) => {
  const size = getSize(iconSize)

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fillColor}
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm3.89 15.19L12 13.3l-3.89 3.89-1.3-1.3L10.7 12 6.81 8.11l1.3-1.3L12 10.7l3.89-3.89 1.3 1.3L13.3 12l3.89 3.89-1.3 1.3z" />
    </svg>
  )
}

export default Error2
